import type Modal from 'bootstrap/js/dist/modal';

declare type Cookieman = {
  show: () => void;
  hide: () => void;
};
declare let cookieman: Cookieman;

/**
 * this is just a dirty quick port to TypeScript.
 */
export default class CookiemanThemeController {
  private _showBackdrop = true;
  private _showSettingsBtn = document.querySelector('[aria-controls="cookieman-settings"]');
  private _modal: Modal | null = null;

  constructor() {
    // show "save" after opening settings
    if (this._showSettingsBtn) {
      this._showSettingsBtn.addEventListener('click', function (ev) {
        const saveBtn = document.querySelector(
          '[data-cookieman-save]:not([data-cookieman-accept-all]):not([data-cookieman-accept-none])',
        ) as HTMLButtonElement | null;
        if (saveBtn) {
          saveBtn.hidden = false;
        }
      });
    }

    cookieman.show = () => {
      import('bootstrap/js/dist/modal')
        .then(
          (ModalModule) => {
            this._modal = new ModalModule.default(
              document.getElementById('cookieman-modal') as HTMLElement,
              {
                backdrop: this._showBackdrop,
              },
            );
            this._modal.show();
          },
        );
    };
    cookieman.hide = () => {
      if (this._modal) {
        this._modal.hide();
      }
    };
  }
}
